import { render, staticRenderFns } from "./GeometryTypeIcon.vue?vue&type=template&id=0f0b24a6&scoped=true"
import script from "./GeometryTypeIcon.vue?vue&type=script&lang=js"
export * from "./GeometryTypeIcon.vue?vue&type=script&lang=js"
import style0 from "./GeometryTypeIcon.vue?vue&type=style&index=0&id=0f0b24a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b24a6",
  null
  
)

export default component.exports